import { IGetPaymentWidgetCheckoutInfoResponse } from '../../../../repositories/billing-accounts/v1/get-payment-widget-checkout-info';
import { IGetCheckoutDataResult } from '../types';

export const mapResponse200 = (response: IGetPaymentWidgetCheckoutInfoResponse): IGetCheckoutDataResult => {
  const { fromBalance, total } = response;

  return {
    balance: fromBalance,
    totalAmount: total,
  };
};
